import { useState } from "react";
type Props = {
  setShowTerms: (data: boolean) => void;
  setAgreed: (data: boolean) => void;
  agreed: boolean;
};
const Terms = ({ setShowTerms, setAgreed, agreed }: Props) => {
  return (
    <>
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50"
        onClick={() => setShowTerms(false)}
      >
        {/* Prevent clicking inside popup from closing it */}
        <div
          className="relative z-50 w-full max-w-2xl bg-surface rounded-[24px] shadow-xl overflow-hidden flex flex-col max-h-[85vh] md:max-h-[75vh]"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center gap-4 p-6 bg-surface-container-low">
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center shrink-0">
              <span className="material-symbols-outlined text-on-primary text-[24px]">
                gavel
              </span>
            </div>

            <div>
              <h2 className="font-headline-md text-headline-md text-on-surface">
                شروط وأحكام استخدام شاشة الخرائط المحمية
              </h2>

              <p className="font-body-sm text-body-sm text-on-surface-variant mt-1">
                الرجاء قراءة الشروط والأحكام بعناية قبل المتابعة
              </p>
            </div>

            {/* Close X */}
            <button
              type="button"
              onClick={() => setShowTerms(false)}
              className="mr-auto w-10 h-10 rounded-full hover:bg-surface-variant flex items-center justify-center transition-colors"
            >
              <span className="material-symbols-outlined text-on-surface-variant">
                close
              </span>
            </button>
          </div>

          {/* Content */}
          <div className="p-6 overflow-y-auto flex-1 font-body-md text-body-md text-on-surface/80 space-y-6">
            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                1. مقدمة
              </h3>

              <p className="leading-relaxed">
                يُرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام شاشة الخرائط
                المحمية. إن دخولك باستخدام رقم الجوال واستلام رمز التحقق (OTP)
                واستخدامك للشاشة يُعد موافقة كاملة وغير مشروطة على الالتزام بهذه
                الشروط والأحكام، وعلى أحكام نظام حماية البيانات الشخصية ولائحته
                التنفيذية داخل المملكة العربية السعودية.
                <ul>
                  -الاختصاص والصلاحية<br />
                  -
                    {" "}
                    تقر بأنك مخوَّل نظامًا من قِبل الجهة التي تمثلها
                    (جمعية/شركة/عميل) لاستخدام شاشة الخرائط الخاصة بحساب منافذ.
                  <br />
                  -
                    {" "}
                    تقر بأن رقم الجوال المُدخل يعود لك وحدك، وأنك المسؤول عن أي
                    استخدام يتم عبره للحصول على رمز التحقق (OTP).
                  <br />
                  -
                    تتحمل المسؤولية الكاملة عن صحة البيانات المدخلة وعن أي
                    استخدام يتم نتيجة إدخال رقم الجوال أو تمرير رمز التحقق
                    للآخرين.
                  <br />
                  -جمع ومعالجة البيانات الشخصية<br />
                </ul>
              </p>
            </section>

            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                2.توافق على أن تقوم شركة منافذ السعودية المحدودة بجمع ومعالجة
                البيانات التالية لأغراض أمنية وتنظيمية:
              </h3>

              <p className="leading-relaxed">
                <ul>
                  -رقم الجوال المستخدم لطلب رمز التحقق (OTP)<br />
                  -
                    سجلات الدخول( تاريخ ووقت الدخول، عدد وتكرار الدخول، محاولات
                    الدخول، وقد يشمل ذلك عنوان IP أو معرف الجهاز عند الضرورة
                    الأمنية) .
                  <br />
                </ul>
              </p>
            </section>

            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                3.يكون الغرض من جمع ومعالجة هذه البيانات هو:
              </h3>

              <p className="leading-relaxed">
                <ul>
                  -
                    التحقق من هويتك قبل السماح بالوصول إلى خرائط المتاجر
                    والجمعيات.
                  <br />
                  -
                    حماية بيانات منافذ وعملائها من الوصول غير المصرح به أو إساءة
                    الاستخدام أو محاولة نسخ أو تسريب البيانات.
                  <br />
                </ul>
              </p>
            </section>

            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                4.لا يتم استخدام هذه البيانات لأي أغراض تسويقية أو تجارية غير
                مرتبطة بهذا الغرض، إلا بموافقة لاحقة وصريحة منك – إن لزم.
              </h3>
            </section>

            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                5.سرية المعلومات واستخدام الشاشة
              </h3>

              <p className="leading-relaxed pb-4">
                <ul>
                  -
                    تلتزم بعدم مشاركة روابط أو شاشات الخرائط المحمية أو بيانات
                    الدخول أو رمز التحقق (OTP) مع أي طرف غير مخول.
                  <br />
                  -
                    يُحظر عليك نسخ أو تصوير أو تصدير أو إعادة استخدام خرائط
                    المتاجر والجمعيات أو أي بيانات تظهر في الشاشة المحمية لغرض
                    منافسة شركة منافذ أو الإضرار بها أو بعملائها أو إفشاء
                    أسرارهم.
                  <br />
                  -
                    تلتزم باستخدام المعلومات التي تظهر في الشاشة المحمية فقط
                    للأغراض المشروعة المرتبطة بالتعاون مع شركة منافذ و/أو الجهة
                    التي تمثّلها، وبما لا يخالف الأنظمة والتعليمات المعمول بها
                    في المملكة العربية السعودية.
                  <br />
                </ul>
              </p>
            </section>
            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                5.حماية البيانات وفق النظام
              </h3>

              <p className="leading-relaxed pb-4">
                <ul>
                  -
                    تلتزم شركة منافذ بتطبيق الضوابط الفنية والتنظيمية اللازمة
                    لحماية بياناتك الشخصية وسجلات الدخول، وفقًا لنظام حماية
                    البيانات الشخصية ولائحته التنفيذية، بما في ذلك تقييد الوصول
                    وتشفير البيانات متى كان ذلك ممكنًا.
                  <br />
                  -
                    تحتفظ شركة منافذ بسجلات الدخول لمدة زمنية مناسبة لأغراض أمن
                    المعلومات والتدقيق، ثم تُتلف أو تُزال هوية صاحبها بما لا
                    يسمح بالتعرّف عليك، إلا إذا تطلّب نظامًا أو نزاعٌ قائم
                    الاحتفاظ بها لمدة أطول.
                  <br />
                </ul>
              </p>
            </section>
            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                5.مشاركة البيانات
              </h3>

              <p className="leading-relaxed pb-4">
                <ul>
                  -
                    لا تُشارك شركة منافذ بياناتك الشخصية أو سجلات الدخول مع أي
                    طرف ثالث إلا في الحالات الآتية:
                    <ul>
                      -
                        الجهات الحكومية أو القضائية المختصة متى طُلب ذلك نظامًا.
                      <br />
                      -
                        {" "}
                        مزودو خدمات تقنية مثل مزودي خدمة إرسال OTP بقدر ما يلزم
                        لتقديم الخدمة، وبموجب التزامات تعاقدية تراعي نظام حماية
                        البيانات الشخصية.
                      <br />
                    </ul>
                  <br />
                  -
                    لا يُسمح بنقل بياناتك لخارج المملكة إلا وفق الضوابط النظامية
                    المقررة.
                  <br />
                </ul>
              </p>
            </section>
            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                5.المسؤولية وإنهاء الاستخدام
              </h3>

              <p className="leading-relaxed pb-4">
                <ul>
                  - 
                    تتحمّل المسؤولية الكاملة عن أي ضرر ينشأ عن إساءة استخدام رقم
                    جوالك أو رمز التحقق أو مشاركة بيانات الدخول أو السماح لغيرك
                    باستخدامها.
                  <br />
                  -
                    تحتفظ شركة منافذ بحقها في إيقاف أو تقييد دخولك إلى شاشة
                    الخرائط المحمية متى رأت وجود إساءة استخدام أو مخالفة لهذه
                    الشروط أو للأنظمة المعمول بها
                  <br />
                </ul>
              </p>
            </section>
            <section>
              <h3 className="font-label-md text-label-md text-primary mb-2">
                5.الإقرار بالموافقة
              </h3>

              <p className="leading-relaxed pb-4">
                باستمرارك في إدخال رقم جوالك، واستلام رمز التحقق (OTP)، واستخدام
                شاشة الخرائط المحمية، فإنك تقر بما يلي:
                <ol>
                  -قرأت وفهمت هذه الشروط والأحكام،<br />
                  -
                    الموافقة على سياسة معالجة بياناتك الشخصية وفقًا لنظام حماية
                    البيانات الشخصية ولائحته التنفيذية،
                 <br />
                  -هذه الموافقة تُعد مرجعًا نظاميًّا لاستخدامك للخدمة.<br />
                </ol>
              </p>
            </section>
          </div>

          {/* Footer */}
          <div className="p-6 bg-surface-container-low shadow-[0_-4px_12px_rgba(0,0,0,0.03)]">
            {/* Buttons */}
            <div className="flex items-center justify-end gap-4">
              {/* Close */}
              <button
                type="button"
                onClick={() => setShowTerms(false)}
                className="px-6 py-3 rounded-full font-label-md text-label-md bg-surface text-on-surface hover:bg-surface-variant transition-colors shadow-sm"
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Terms;
